import { tokenABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

const contracts: { [key: number]: { contract: any; address: string } } = {
  0: { contract: null, address: '0x9C65AB58d8d978DB963e63f2bfB7121627e3a739' },
  1: { contract: null, address: '0xAEE4164c1ee46ed0bbC34790f1a3d1Fc87796668' },
  2: { contract: null, address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c' },
  3: { contract: null, address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c' },
  4: { contract: null, address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8' },
  5: { contract: null, address: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402' },
  6: { contract: null, address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56' },
  7: { contract: null, address: '0x55d398326f99059fF775485246999027B3197955' },
  8: { contract: null, address: '0x52cff644a7681b5dd7a607b6c8764879b35fe0ae' },
  9: { contract: null, address: '0xc5e6689c9c8b02be7c49912ef19e79cf24977f03' },
};

export const initContract = (pid: number) => {
  if (window.web3 && contracts[pid].contract === null) {
    contracts[pid].contract = new window.web3.eth.Contract(
      tokenABI,
      contracts[pid].address
    );
  }
};

export const balanceOf = async (pid: number, account: string) => {
  if (!account) return new BigNumber(0);
  initContract(pid);
  try {
    if (pid === 2) {
      const amount = await window.web3.eth.getBalance(account);
      return new BigNumber(
        amount ? window.web3.utils.fromWei(amount, 'ether') : 0
      );
    }
    const amount = await contracts[pid].contract.methods
      .balanceOf(account)
      .call();
    return new BigNumber(
      amount ? window.web3.utils.fromWei(amount, 'ether') : 0
    );
  } catch (e) {
    // @ts-ignore
    console.log(e);
    return new BigNumber(0);
  }
};

export const allowance = async (pid: number, account: string) => {
  if (!account) return new BigNumber(0);
  initContract(pid);
  try {
    const amount = await contracts[pid].contract.methods
      .allowance(account, process.env.VUE_APP_SOLO_BANK_CONTRACT_ADDRESS)
      .call();
    return new BigNumber(window.web3.utils.fromWei(amount, 'ether'));
  } catch (e) {
    // @ts-ignore
    console.log(e);
    return new BigNumber(0);
  }
};

export const approve = async (pid: number, account: string) => {
  initContract(pid);
  if (!account) {
    return;
  }
  try {
    contracts[pid].contract.methods
      .approve(
        process.env.VUE_APP_SOLO_BANK_CONTRACT_ADDRESS,
        window.web3.utils.toWei(`10000000`, 'ether')
      )
      .send({
        from: account,
      })
      .once('transactionHash', (hash: string) => {
        // EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
      })
      .on('error', (error: string) => {
        EventBus.$emit(`token-approve-status-${pid}`, 'error');
      })
      .then(() => {
        EventBus.$emit(`token-approve-status-${pid}`, 'completed');
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};
